import { render, staticRenderFns } from "./BannerTwo.vue?vue&type=template&id=5fb358d4&scoped=true&"
import script from "./BannerTwo.vue?vue&type=script&lang=js&"
export * from "./BannerTwo.vue?vue&type=script&lang=js&"
import style0 from "./BannerTwo.vue?vue&type=style&index=0&id=5fb358d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb358d4",
  null
  
)

export default component.exports